export function formatDate(date: string | Date, locale?: string, options?: Record<string, string>) {
  return new Intl.DateTimeFormat(locale, options).format(new Date(date));
}

// using for payment fragment due dates in order to be in store timezone 
export function formatISODate(date: string) {
  const [y, m, d] = date.split('-').map(Number);
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  }).format(new Date(y, m - 1, d));
}
